import { wsService } from "./wsService";

const section = "purchase-remitos";
const STATE_UNBILLED = 0;
const STATE_BILLED = 1;

function filter(param) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_post_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get_states(param = {}) {
  return wsService.make_get_request(section + "/states", param);
}

function getStateHtml(state) {
  switch (parseInt(state.id)) {
    case STATE_UNBILLED:
      return '<p class="state_accounting_unbilled">' + state.name + "</p>";
    case STATE_BILLED:
      return '<p class="state_accounting_billed">' + state.name + "</p>";
    default:
      return "-";
  }
}

function getSpents(param = {}) {
  return wsService.make_post_request(section + "/get_spents", param);
}

function setSpent(param = {}) {
  return wsService.make_post_request(section + "/set_spent", param);
}

function deleteComprobante(id) {
  return wsService.make_delete_request(section + "/delete-comprobante/" + id);
}
export const purchaseRemitoService = {
  section,
  get_states,
  getStateHtml,
  filter,
  remove,
  create,
  update,
  getSpents,
  setSpent,
  deleteComprobante,
  //Constants
  STATE_UNBILLED,
  STATE_BILLED,
};
